<template>
  <section class="l-content">
    <el-card>
      <el-form :inline="true" :model="condition">
        <el-form-item label="状态">
          <el-select v-model="condition.status" placeholder="选择状态" clearable style="width: 150px;">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="申诉中" :value="1"></el-option>
            <el-option label="申诉通过" :value="2"></el-option>
            <el-option label="申诉不通过" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPageData()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-divider></el-divider>
    <el-card v-if="pageData">
      <l-table :option="tableOption" :data="pageData.list" :start-index="pageData.startIndex">
        <template slot="status" slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
        </template>
      </l-table>
      <l-pager :page="pageData" @change="getPageData"></l-pager>
    </el-card>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['userInfo'])
  },
  name: 'CleanAppealList',
  data() {
    return {
      tableOption: {
        stripe: true,
        height: document.documentElement.clientHeight - 280 + 'px',
        columns: [
          { label: '序号', type: 'index', width: 60 },
          { label: '任务ID', prop: 'task_id', width: 80 },
          { label: '工人姓名', prop: 'worker_name', width: 120 },
          { label: '申诉理由', prop: 'appeal_reason', minWidth: 200 },
          { label: '申诉时间', prop: 'create_time', width: 160 },
          { label: '状态', slot: 'status', width: 100 },
          { label: '处理人', prop: 'handle_user_name', width: 100 },
          { label: '处理时间', prop: 'handle_time', width: 160 }
        ],
        operation: {
          width: '200',
          buttons: [
            { type: 'primary', icon: 'el-icon-view', label: '详情', click: this.viewDetail },
            { type: 'success', icon: 'el-icon-check', label: '通过', click: this.handlePass, disabled: row => row.status !== 1 },
            { type: 'danger', icon: 'el-icon-close', label: '不通过', click: this.handleReject, disabled: row => row.status !== 1 }
          ]
        }
      },
      condition: {
        status: 1,
        pageIndex: 1,
        pageSize: 15
      },
      pageData: null
    }
  },
  created() {
    this.getPageData()
  },
  methods: {
    getStatusType(status) {
      const map = {
        1: 'warning',
        2: 'success',
        3: 'danger'
      }
      return map[status] || 'info'
    },
    getStatusText(status) {
      const map = {
        1: '申诉中',
        2: '申诉通过',
        3: '申诉不通过'
      }
      return map[status] || '未知'
    },
    async getPageData(pageOption) {
      Object.assign(this.condition, pageOption)
      this.pageData = await this.$lgh.get('api/clean/appeal/list', {
        enterpriseCode: this.userInfo.enterpriseCode,
        status: this.condition.status,
        pageIndex: this.condition.pageIndex,
        pageSize: this.condition.pageSize
      })
    },
    async viewDetail(item) {
      const detail = await this.$lgh.get('api/clean/appeal/info', { appealId: item.appeal_id })
      if (!detail) return
      let html = `
        <div>
          <p><strong>任务ID：</strong>${detail.appeal.task_id}</p>
          <p><strong>工人姓名：</strong>${detail.appeal.worker_name}</p>
          <p><strong>申诉理由：</strong>${detail.appeal.appeal_reason}</p>
          <p><strong>申诉时间：</strong>${detail.appeal.create_time}</p>
          <p><strong>当前状态：</strong>${this.getStatusText(detail.appeal.status)}</p>
          ${detail.task ? `<p><strong>地点：</strong>${detail.task.location_name}</p>` : ''}
          ${detail.appeal.handle_remark ? `<p><strong>处理备注：</strong>${detail.appeal.handle_remark}</p>` : ''}
        </div>
      `
      this.$lgh.openDialog({
        title: '申诉详情',
        content: html,
        showCancel: false
      })
    },
    handlePass(item) {
      this.handle(item, 2, '确认通过该申诉？')
    },
    handleReject(item) {
      this.handle(item, 3, '确认不通过该申诉？')
    },
    async handle(item, result, confirmMsg) {
      this.$lgh.msgConfirm(confirmMsg, async () => {
        await this.$lgh.post('api/clean/appeal/handle', {
          appealId: item.appeal_id,
          result: result,
          remark: ''
        })
        this.$lgh.notifySuccess('处理成功')
        this.getPageData()
      })
    }
  }
}
</script>
